// BNZ Timer Bar JavaScript
document.addEventListener('DOMContentLoaded', function() {
  // Adjust header positioning when timer bar is present
  function adjustHeaderPosition() {
    const timerBar = document.querySelector('.bnz-timer-bar');
    
    if (timerBar) {
      // Add class to body when timer bar is present
      document.body.classList.add('timer-bar-active');
    } else {
      // Remove class when timer bar is not present
      document.body.classList.remove('timer-bar-active');
    }
  }
  
  // Run adjustment immediately
  adjustHeaderPosition();

  // Initialize message rotation
  const timerBarsWithMessages = document.querySelectorAll('.bnz-timer-bar');
  
  timerBarsWithMessages.forEach(function(timerBar) {
    const messagesContainer = timerBar.querySelector('.bnz-timer-bar__messages');
    
    if (!messagesContainer) return;
    
    const messages = messagesContainer.querySelectorAll('.bnz-timer-bar__message');
    const enableRotation = timerBar.getAttribute('data-enable-rotation') === 'true';
    const rotationInterval = parseInt(timerBar.getAttribute('data-rotation-interval') || '5', 10) * 1000;
    
    // Ensure all messages are properly initialized (CSS handles visibility)
    
    // Only rotate if there's more than one message and rotation is enabled
    if (messages.length > 1 && enableRotation) {
      // Find the currently active message
      let currentIndex = 0;
      messages.forEach(function(message, index) {
        if (message.classList.contains('active')) {
          currentIndex = index;
        }
      });
      
      function rotateMessages() {
        // Remove active class from current message
        const currentMessage = messages[currentIndex];
        currentMessage.classList.remove('active');
        
        // Move to next message
        currentIndex = (currentIndex + 1) % messages.length;
        
        // Add active class to next message
        const nextMessage = messages[currentIndex];
        nextMessage.classList.add('active');
      }
      
      // Set up rotation interval
      const rotationTimer = setInterval(rotateMessages, rotationInterval);
      
      // Store interval reference for cleanup
      timerBar._rotationInterval = rotationTimer;
    } else if (messages.length === 1) {
      // If only one message, ensure it's visible
      messages[0].classList.add('active');
    }
  });
  
  // Initialize all timer bars on the page
  const timerBars = document.querySelectorAll('.bnz-timer-bar[data-timer-date]');
  
  timerBars.forEach(function(timerBar) {
    const timerDate = timerBar.getAttribute('data-timer-date');
    const countdownElement = timerBar.querySelector('[id^="bnz-countdown-"]');
    
    if (!countdownElement || !timerDate) return;

    const targetDate = new Date(timerDate).getTime();
    
    function updateCountdown() {
      const now = new Date().getTime();
      const distance = targetDate - now;

      if (distance <= 0) {
        // Timer expired – deactivate and remove the timer bar
        if (timerBar._countdownInterval) {
          clearInterval(timerBar._countdownInterval);
        }
        if (timerBar && timerBar.parentNode) {
          timerBar.parentNode.removeChild(timerBar);
        }
        // Re-evaluate header position / body class state
        adjustHeaderPosition();
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      const daysElement = countdownElement.querySelector('[data-days]');
      const hoursElement = countdownElement.querySelector('[data-hours]');
      const minutesElement = countdownElement.querySelector('[data-minutes]');
      const secondsElement = countdownElement.querySelector('[data-seconds]');

      if (daysElement) daysElement.textContent = days.toString().padStart(2, '0');
      if (hoursElement) hoursElement.textContent = hours.toString().padStart(2, '0');
      if (minutesElement) minutesElement.textContent = minutes.toString().padStart(2, '0');
      if (secondsElement) secondsElement.textContent = seconds.toString().padStart(2, '0');
    }

    // Update immediately
    updateCountdown();
    
    // Update every second
    const countdownInterval = setInterval(updateCountdown, 1000);

    // Store interval reference for cleanup
    timerBar._countdownInterval = countdownInterval;
  });

  // Clean up intervals when page unloads
  window.addEventListener('beforeunload', function() {
    timerBars.forEach(function(timerBar) {
      if (timerBar._countdownInterval) {
        clearInterval(timerBar._countdownInterval);
      }
    });
    
    timerBarsWithMessages.forEach(function(timerBar) {
      if (timerBar._rotationInterval) {
        clearInterval(timerBar._rotationInterval);
      }
    });
  });
});
